import { useState, useEffect } from 'react';
import { getDepartments } from '../lib/api';

// Static fallback (used before fetch resolves or if the request fails)
export const FALLBACK_DEPARTMENTS = [
  'Marketing', 'Human Resources Management', 'Travel', 'Design & Development',
  'Accounts (Credit & Collection)', 'Operations', 'Sales', 'Sales Coordinators',
];

let _cache = null;

// Returns the full list of departments including any manually-added ones.
export const useDepartments = () => {
  const [departments, setDepartments] = useState(_cache || FALLBACK_DEPARTMENTS);
  useEffect(() => {
    let active = true;
    getDepartments()
      .then((r) => {
        const list = Array.isArray(r.data) && r.data.length ? r.data : FALLBACK_DEPARTMENTS;
        _cache = list;
        if (active) setDepartments(list);
      })
      .catch(() => {});
    return () => { active = false; };
  }, []);
  return departments;
};
